// extracted by mini-css-extract-plugin
module.exports = {"textSmall":"styles_textSmall__g_f7o","linkInline":"styles_linkInline__rCqsM","tokenLink":"styles_tokenLink__fB0dV"};